import {DisplayMinute} from "../../directives/display.minute";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";
import {Utils} from "../../model/Utils";


export class ExplainBreak{

  constructor(
              private domSanitizer: DomSanitizer,
              private translate: TranslateService) {
    }

  public explainBreak(breakMustBePaid: boolean, normalBreak: number, breakDuration: number, durationToRemove: number):SafeHtml{
    let res = '';
    this._debug('explainBreak ' + breakMustBePaid + ' normal: ' + normalBreak + ' duration: ' + breakDuration + ' toRemove: ' + durationToRemove);
    //if (durationToRemove>0){
      const displayMinute = new DisplayMinute();
      if (breakMustBePaid){
        if ((Utils.isNullOrUndefined(breakDuration) || breakDuration===0)){
          res = this.translate.instant('BreakIsPaidButNotTaken', {normalBreakDuration:  displayMinute.transform(normalBreak),
            notPaid: displayMinute.transform(durationToRemove)});
          this._debug('6: ' +  res);
        }else{
          if (breakDuration === normalBreak){
            if (!Utils.isNullOrUndefined(durationToRemove) && durationToRemove!==0){
              res = this.translate.instant('BreakIsPaidAsNormalButSomeWontBePaid',{normalBreakDuration:  displayMinute.transform(normalBreak), notPaid: displayMinute.transform(durationToRemove)});
              this._debug('1: ' +  res);
            }else{
              res = this.translate.instant('BreakIsPaid',{breakDuration:  displayMinute.transform(breakDuration)});
              this._debug('2: ' +  res);
            }
          }
          if (breakDuration < normalBreak){
            if (Utils.isNullOrUndefined(durationToRemove) || durationToRemove===0) {
              res = this.translate.instant('BreakIsPaidAsNormal',{normalBreakDuration:  displayMinute.transform(normalBreak)});
              this._debug('3: ' +  res);
            }else{
              res = this.translate.instant('BreakIsPaidAsNormalButSomeWontBePaid',{normalBreakDuration:  displayMinute.transform(normalBreak), notPaid: displayMinute.transform(durationToRemove)});
              this._debug('4: ' +  res);
            }

          }
          if (breakDuration > normalBreak){
            // res = this.translate.instant('BreakIsPaidFor', {normalBreakDuration:  displayMinute.transform(normalBreak),notPaid: displayMinute.transform(breakDuration - normalBreak)});
            res = this.translate.instant('BreakIsPaidFor', {normalBreakDuration:  displayMinute.transform(normalBreak),
              notPaid: displayMinute.transform(durationToRemove)});
            this._debug('5: ' +  res);
          }
        }
      }else{
        res = this.translate.instant('BreakIsNotPaid',{breakDuration:displayMinute.transform(breakDuration) , notPaid: displayMinute.transform(durationToRemove)});
        this._debug('7: ' +  res);
      }
   // }

    return this.domSanitizer.bypassSecurityTrustHtml(res);
  }


  private _debug(data: string){
   // console.log(data);
  }

}
